import { listOption } from '@/api/business/shipAccount'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOption)
